/* @flow */
import { createStore, applyMiddleware, compose } from "redux";
import uniq from "lodash/uniq";
import reducer from "./reducer";

const persistor = store => {
  const initialState = store.getState();

  if (initialState.profile == null) {
    try {
      const stored = localStorage.getItem("locale");

      if (stored != null) {
        store.dispatch({
          type: "UPDATE_LOCALE",
          payload: stored
        });
      }
    } catch (error) {
      // TODO: Отчитаться о проблеме с localStorage
    }
  }

  return next => action => {
    const prevState = store.getState();
    const result = next(action);
    const nextState = store.getState();

    if (action.type === "UPDATE_WATCHED_VIDEOS") {
      try {
        const stored = localStorage.getItem("watchedVideos");

        if (stored === null) {
          localStorage.setItem(
            "watchedVideos",
            JSON.stringify([action.payload])
          );
        }

        if (stored !== null) {
          localStorage.setItem(
            "watchedVideos",
            JSON.stringify(uniq([...JSON.parse(stored), action.payload]))
          );
        }
      } catch (error) {}
    }

    if (action.type === "UPDATE_LOCALE") {
      try {
        localStorage.setItem("locale", action.payload);
      } catch (error) {
        // TODO: Отчитаться о проблеме с localStorage
      }
    }

    if (action.type === "RECEIVE_PROFILE") {
      const { id } = action.payload;

      try {
        const stored = localStorage.getItem(`persist:${id}:settings`);

        if (stored != null) {
          store.dispatch({
            type: "RECEIVE_SETTINGS",
            payload: JSON.parse(stored)
          });
        } else {
          store.dispatch({
            type: "DROP_SETTINGS",
            currency: action.payload.currency
          });
        }
      } catch (error) {
        // TODO: Отчитаться о проблеме с localStorage
      }

      try {
        const stored = localStorage.getItem(`persist:${id}:tabs`);

        if (stored != null) {
          store.dispatch({
            type: "RECEIVE_TABS",
            payload: JSON.parse(stored)
          });
        }
      } catch (error) {
        // TODO: Отчитаться о проблеме с localStorage
      }
    } else if (nextState.profile) {
      const { id } = nextState.profile;

      if (nextState.settings !== prevState.settings) {
        try {
          localStorage.setItem(
            `persist:${id}:settings`,
            JSON.stringify(nextState.settings)
          );
        } catch (error) {
          // TODO: Отчитаться о проблеме с localStorage
        }
      }

      if (nextState.tabs !== prevState.tabs) {
        try {
          localStorage.setItem(
            `persist:${id}:tabs`,
            JSON.stringify(nextState.tabs)
          );
        } catch (error) {
          // TODO: Отчитаться о проблеме с localStorage
        }
      }
    }

    if (nextState.fallbackLocale !== prevState.fallbackLocale) {
      try {
        localStorage.setItem("locale", nextState.fallbackLocale);
      } catch (error) {
        // TODO: Отчитаться о проблеме с localStorage
      }
    }

    return result;
  };
};

export default function createSpecificStore(initialState: Object = {}) {
  const middleware = applyMiddleware(persistor);

  let store = null;

  if (
    process.env.NODE_ENV === "development" &&
    window.__REDUX_DEVTOOLS_EXTENSION__
  ) {
    const composeEnhancers =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    store = createStore(reducer, initialState, composeEnhancers(middleware));
  } else {
    store = createStore(reducer, initialState, middleware);
  }

  let listeners = [];

  store.subscribeToActions = listener => {
    listeners.push(listener);

    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  };

  let originalDispatch = store.dispatch.bind(store);

  store.dispatch = action => {
    listeners.forEach(listener => {
      listener(action);
    });
    return originalDispatch(action);
  };

  return store;
}



// WEBPACK FOOTER //
// ./src/redux/createStore.js